import { Layout } from "antd";
import React from "react";

const { Footer } = Layout;

function Foot() {
  return (
    <Footer style={{ textAlign: "center", color: "#8c8c8c", fontSize: 13 }}>
      © {new Date().getFullYear()} Ryo Solutions — Módulo Contable NIIF / COLGAAP
    </Footer>
  );
}

export default Foot;
